export enum adminOpenJobRegionsTypes {
  FETCH_ADMIN_OPEN_JOB_REGIONS_REQUEST = "FETCH_ADMIN_OPEN_JOB_REGIONS_REQUEST",
  FETCH_ADMIN_OPEN_JOB_REGIONS_SUCCESS = "FETCH_ADMIN_OPEN_JOB_REGIONS_SUCCESS",
  FETCH_ADMIN_OPEN_JOB_REGIONS_FAILURE = "FETCH_ADMIN_OPEN_JOB_REGIONS_FAILURE",
}